import axios from 'axios';

export default {
  // /api/project/adminuser/slelelele/insights/contributors?beforeDate=2021-01-01&afterDate=2020-01-01
  getContributorsAnalytics(alias, projectAlias, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/insights/contributors`, { params })
      .then((res) => res?.data)
      .catch((err) => {
        throw err;
      });
  },
};
